// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
    #submit-claim {
        top: 0px;
        transition: 0.5s;
    }
    #submit-claim:hover {
        top: -10px;
        transition: 0.5s;
        animation-name: updown;
        animation-duration: 0.8s;
        animation-iteration-count: infinite;
        animation-delay: 0.5s;
    }

    @keyframes updown {
        0% {
            top: -10px
        }
        50% {
            top: -6px
        }
        100% {
            top: -10px;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/hyperwolf-footer.css"],"names":[],"mappings":"AAAA;IACI;QACI,QAAQ;QACR,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,gBAAgB;QAChB,sBAAsB;QACtB,wBAAwB;QACxB,mCAAmC;QACnC,qBAAqB;IACzB;;IAEA;QACI;YACI;QACJ;QACA;YACI;QACJ;QACA;YACI,UAAU;QACd;IACJ;AACJ","sourcesContent":["@media (min-width: 768px) {\n    #submit-claim {\n        top: 0px;\n        transition: 0.5s;\n    }\n    #submit-claim:hover {\n        top: -10px;\n        transition: 0.5s;\n        animation-name: updown;\n        animation-duration: 0.8s;\n        animation-iteration-count: infinite;\n        animation-delay: 0.5s;\n    }\n\n    @keyframes updown {\n        0% {\n            top: -10px\n        }\n        50% {\n            top: -6px\n        }\n        100% {\n            top: -10px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
